import { SxProps, Theme } from '@mui/material';

export const titleSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-xl)',
	fontWeight: '800',
	color: '#333333',
	letterSpacing: '0px',
	// width: '50%',
};

export const subtitleSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-small)',
	fontWeight: 'bold',
	color: '#2C2C2C',
	letterSpacing: '0px',
	/* marginTop: '18px', */
};

export const subtitleFirstSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-small)',
	fontWeight: 'bold',
	color: '#2C2C2C',
	letterSpacing: '0px',
	marginTop: '12px',
};

export const questionSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-body)',
	fontWeight: 'normal',
	color: '#2C2C2C',
	letterSpacing: '0px',
	marginTop: '6px',
	marginBottom: '8px',
	marginLeft: '0px',
	marginRight: '0px',
};

export const mainContainerFormSX: SxProps<Theme> = (theme) => ({
	display: 'flex',
	flexDirection: 'column',
	marginTop: '40px',
	marginLeft: '160px',
	marginRight: '160px',
	marginBottom: '50px',
	padding: '40px',
	background: '#FFFFFF 0% 0% no-repeat padding-box',
	borderRadius: '6px',
	[theme.breakpoints.down('md')]: {
		flexDirection: 'column',
		margin: '0px',
		padding: '20px',
		backgroundColor: 'transparent',
	},
});

export const containerFormRightSX: SxProps<Theme> = (theme) => ({
	borderRadius: '4px',
	width: '50%',
	paddingRight: '20px',
	[theme.breakpoints.down('md')]: {
		paddingRight: '0px',
		width: '100%',
	},
});

export const containerFormLeftSX: SxProps<Theme> = (theme) => ({
	borderRadius: '4px',
	width: '50%',
	paddingLeft: '20px',
	flexBasis: '50%',
	[theme.breakpoints.down('md')]: {
		paddingLeft: '0px',
		width: '100%',
	},
});

export const buttonFormSX: SxProps<Theme> = {
	width: '100px',
	height: '48px',
	background: '#FFF',
	color: '#2C2C2C',
	borderColor: '#C9C9C9',
	fontWeight: 'normal',
	marginRight: '10px',
	borderRadius: '4px',
	'&:hover': {
		borderColor: '#011688',
	},
	'&.MuiButton-contained': {
		backgroundColor: '#011688',
		color: '#FFF',
	},
};

export const marginSX: SxProps<Theme> = (theme) => ({
	marginBottom: '17px',
	[theme.breakpoints.down('md')]: {
		marginBottom: '17px',
	},
});

export const questionsContainerSX: SxProps<Theme> = (theme) => ({
	display: 'flex',
	flexDirection: 'row',
	[theme.breakpoints.down('md')]: {
		flexDirection: 'column',
	},
});
